//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { Box, Button, Flex } from "@chakra-ui/react";
import { Field, Formik } from "formik";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { array, object, string } from "yup";
import { FFormContext, FFormField } from "../../../primitives/forms/FormField";
import TeacherOptions from "../components/TeacherOptions";

const validationSchema = object().shape({
  teacherOption: string().required("Select a preferred option"),
  gender: array().of(string()).min(1, "Select the gender(s) for the tutor"),
});

type TeacherOptionsFormProps = {
  onSubmit: any;
  dataInput: any;
  viewModel: any;
  initialValues: {
    teacherOption: any;
    gender?: any;
  };
  loading?: boolean;
  updateFormIndex: any;
  displayGender?: boolean;
  nextButtonText?: string;
};

const TeacherOptionsForm: React.FC<TeacherOptionsFormProps> = observer(
  ({
    onSubmit,
    dataInput,
    viewModel,
    loading,
    updateFormIndex,
    displayGender,
    initialValues,
    nextButtonText = "Next: Schedule",
  }) => {
    return (
      <FFormContext.Provider
        value={{
          placeholders: {
            gender: {
              placeholder: "",
              label: "Select the gender of the tutor",
            },
          },
        }}
      >
        <Formik
          key={viewModel.teacherOption}
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {({ values, handleSubmit }) => {
            return (
              <form onSubmit={handleSubmit}>
                <Field name="teacherOption">
                  {({ field, form }) => (
                    <TeacherOptions
                      dataInput={dataInput}
                      value={field.value}
                      onChangeCallback={updateFormIndex}
                      onChange={(value) => {
                        form.setFieldValue(field.name, value);
                      }}
                    />
                  )}
                </Field>

                <Box mt={8} />
                {displayGender && (
                  <FFormField
                    name="gender"
                    type="checkbox"
                    checkboxSpacing={(i) => ({ ml: i > 0 ? 8 : 0 })}
                    options={["male", "female"].map((o) => ({
                      label: o,
                      value: o,
                    }))}
                  />
                )}

                <Flex mt={8} justify={["none", "flex-end"]}>
                  <Button
                    colorScheme="blue"
                    type="submit"
                    size="lg"
                    width={["100%", "100%", "100%", "50%"]}
                  >
                    {nextButtonText}
                  </Button>
                </Flex>
              </form>
            );
          }}
        </Formik>
      </FFormContext.Provider>
    );
  }
);

TeacherOptionsForm.defaultProps = {
  onSubmit: (data) => alert(JSON.stringify(data)),
};

export default TeacherOptionsForm;
